import { render, staticRenderFns } from "./StudentMatchingInfoForm.vue?vue&type=template&id=21c7d42b&scoped=true&"
import script from "./StudentMatchingInfoForm.vue?vue&type=script&lang=js&"
export * from "./StudentMatchingInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./StudentMatchingInfoForm.vue?vue&type=style&index=0&id=21c7d42b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7d42b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VForm,VSelect,VSwitch,VTextField,VTextarea})
